import { useQuery } from 'react-query'
import { getMoneyPoolManagement } from 'services/fund'
import { capabilitiesFor } from './resolve'

export { capabilitiesFor, capabilitiesForRole } from './resolve'
export type { IResolvedCapabilities } from './resolve'

/**
 * The viewer's capabilities in `fundId`, read off the fund detail query the
 * fund page already keeps warm (same key as useGetMoneyPoolManagement), so on
 * most screens this costs no extra request. `fallbackRole` (e.g. a role handed
 * over in navigation state) answers until the detail arrives.
 */
export function useFundCapabilities(
    fundId: string | number | undefined | null,
    fallbackRole?: string | null
) {
    const key = fundId == null || fundId === '' ? undefined : String(fundId)
    const { data, isLoading } = useQuery(
        ['moneyPool-management', key],
        getMoneyPoolManagement,
        { enabled: Boolean(key), staleTime: 60_000 }
    )
    return {
        ...capabilitiesFor(data, fallbackRole),
        isLoading: Boolean(key) && isLoading,
    }
}
